import { gfs } from '../../utils/functional'
import { keys } from 'ramda'

function getStoredChannelPromoteCode() {
  try {
    const promoteCode = localStorage.getItem('promote-code')
    if (!promoteCode) return ''
    try {
      return JSON.parse(promoteCode) || ''
    } catch (e) {
      return promoteCode
    }
  } catch (e) {
    return ''
  }
}

const UPDATE_SHOW_MOBILE_MESSAGE = 'UPDATE_SHOW_MOBILE_MESSAGE'
const CLEAR_SHOW_MOBILE_MESSAGE = 'CLEAR_SHOW_MOBILE_MESSAGE'
const UPDATE_WORKBENCH_QR_CODE = 'UPDATE_WORKBENCH_QR_CODE'
const UPDATE_CHANNEL_PROMOTE_CODE = 'UPDATE_CHANNEL_PROMOTE_CODE'
const channelPromoteCode = getStoredChannelPromoteCode()
const state = {
  showMobileMessage: true,
  workBenchQrcode: null,
  channelPromoteCode,
  isChannelPromoter: !!channelPromoteCode
}
export default {
  namespaced: false,
  state,
  mutations: {
    [UPDATE_SHOW_MOBILE_MESSAGE](state, data) {
      state.showMobileMessage = false
    },
    [CLEAR_SHOW_MOBILE_MESSAGE](state, data) {
      state.showMobileMessage = true
    },
    [UPDATE_WORKBENCH_QR_CODE](state, data) {
      state.workBenchQrcode = data
    },
    [UPDATE_CHANNEL_PROMOTE_CODE](state, data) {
      state.channelPromoteCode = data
      state.isChannelPromoter = !!data
    }
  },
  actions: {
    upDateShowMobileMessage({ commit }) {
      commit(UPDATE_SHOW_MOBILE_MESSAGE)
    },
    clearShowMobileMessage({ commit }, params) {
      commit(CLEAR_SHOW_MOBILE_MESSAGE, params)
    },
    workbenchQrCodeChange({ commit }, params) {
      commit(UPDATE_WORKBENCH_QR_CODE, params)
    },
    channelPromoteCodeChange({ commit }, params) {
      commit(UPDATE_CHANNEL_PROMOTE_CODE, params)
    }
  },
  getters: {
    ...gfs(keys(state))
  }
}
